// export const BASE_URL = 'https://dev-bluegdpr-be.bmarcin.site';
export const BASE_URL = 'https://sharemedix-be.vsi.health';
